import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const StepTitleStyled = styled.h3`
  font-size: 2.4rem;
  line-height: 3.2rem;
  margin: 0;
`;

export const StepSubtitleStyled = styled.div`
  font-size: 1.8rem;
  line-height: 2.8rem;
  margin-bottom: 4rem;
  margin-top: 0;
  color: ${colors.neutral[800]};
  text-align: center;
`;

export const StepNumberStyled = styled.span`
  background-color: ${colors.green[600]};
  border-radius: 50%;
  color: ${colors.neutral.white};
  font-size: 1.6rem;
  line-height: 1.8rem;
  font-weight: 700;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
